import hres8axLabels from 'assets/labels/hres8ax'
import faker from 'faker'
// import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres8axLabels
    }
  },
  detailIndex () {
    let mockDetailIndex = {
      dteempdb_y: faker.random.number().toString().substr(0, 1),
      dteempdb_m: faker.random.number().toString().substr(0, 1)
    }

    return {
      detailindex: mockDetailIndex
    }
  },
  detailSalary () {
    let mockSalary = {
      amtincom1: faker.random.number().toString().substr(0, 1),
      amtinct: faker.random.number().toString().substr(0, 1),
      amtsalyr: faker.random.number().toString().substr(0, 1),
      amtotht: faker.random.number().toString().substr(0, 1),
      amtsale: faker.random.number().toString().substr(0, 1),
      amttaxt: faker.random.number().toString().substr(0, 1),
      amtothyr: faker.random.number().toString().substr(0, 1),
      amtsalt: faker.random.number().toString().substr(0, 1),
      dteyrepay: faker.random.number().toString().substr(0, 1)
    }

    return {
      salary: mockSalary
    }
  },
  detailDeduction () {
    let mockTable1Rows = []
    const mockTable1Total = 5
    for (var i = 1; i <= mockTable1Total; i++) {
      mockTable1Rows.push({
        coddeduct: faker.lorem.word(),
        desc_coddeduct: faker.lorem.word(),
        amtdeduct: faker.random.number().toString().substr(0, 1),
        amtdisable: 'N'
      })
    }

    let mockTable2Rows = []
    const mockTable2Total = 5
    for (var j = 1; j <= mockTable2Total; j++) {
      mockTable2Rows.push({
        coddeduct: faker.lorem.word(),
        desc_coddeduct: faker.lorem.word(),
        amtdeduct: faker.random.number().toString().substr(0, 1),
        amtdisable: 'N'
      })
    }

    return {
      table1: {
        total: mockTable1Total,
        rows: mockTable1Rows
      },
      table2: {
        total: mockTable2Total,
        rows: mockTable2Rows
      }
    }
  },
  detailInvest () {
    let mockInvestRows = []
    const mockInvestTotal = 5
    for (var j = 1; j <= mockInvestTotal; j++) {
      mockInvestRows.push({
        coddeduct: faker.lorem.word(),
        desc_coddeduct: faker.lorem.word(),
        amtdeduct: faker.random.number().toString().substr(0, 1)
      })
    }
    return {
      invest: {
        total: mockInvestTotal,
        rows: mockInvestRows
      }
    }
  },
  detailCaltax () {
    let mockCaltax = {
      amtdeduct: faker.random.number().toString().substr(0, 1),
      amtsalyr: faker.random.number().toString().substr(0, 1),
      amttax: faker.random.number().toString().substr(0, 1),
      ratetax: faker.random.number().toString().substr(0, 1),
      amtsalt: faker.random.number().toString().substr(0, 1),
      dteyrepay: faker.random.number().toString().substr(0, 1)
    }
    return {
      caltax: mockCaltax
    }
  },
  popupDetailDeduction () {
    let mockPopupDetailDeduction = {
      coddeduct: faker.lorem.word(),
      desc_coddeduct: faker.lorem.word(),
      amtdeduct: faker.random.number().toString().substr(0, 1)
    }

    return mockPopupDetailDeduction
  },
  save () {
    return labels.mockPostMessage
  },
  cancel () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres8ax/mocker.js